/* eslint-disable @typescript-eslint/ban-ts-comment */
import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';

import { checkForErrors } from '.';
import { PypeConfig } from '../xstate/prostudio.api-service.types';

export const loadPypeConfig = async ({
  projectId,
  pypeId,
  env,
}: {
  projectId: string;
  pypeId: string;
  env: 'live' | 'sandbox';
}): Promise<PypeConfig | void> => {
  const getPypeConfig = {
    live: urqlGql.getPypeConfigLive,
    sandbox: urqlGql.getPypeConfigSandbox,
  };

  const response = await getPypeConfig[env as 'live' | 'sandbox']({
    projectId,
    pypeId,
  });

  checkForErrors(response);

  const option =
    env === 'live'
      ? 'getV3ConfigurationPypePypeId'
      : 'getV3ConfigurationPypePypeIdSandbox';

  // @ts-ignore
  const pypeConfig = response.data?.[option];

  return pypeConfig;
};
